import { useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { Form } from "./Form";
import { IPermissionProps } from "../../../../models/Login";
import { IQuestion, Table } from "./Table";

export const TrainingQuestions = (permission: IPermissionProps) => {
    const [modal, setModal] = useState({ singleData: {}, open: false } as { open: boolean, singleData: IQuestion });
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => setModal({ open: false, singleData: {} });
    const reloadTable = () => setReload(!reload);

    return (
        <>
            {(permission.is_Create || permission.is_Update) && <Form open={modal.open} singleData={modal.singleData} hideDialog={hideDialog} reloadTable={reloadTable} toast={toast} />}
            <Table setModal={setModal} permissions={permission} reload={reload} toast={toast} />

            <Toast ref={toast} />
        </>
    );
}